export const HEROKU_APP_NAME = import.meta.env.VITE_HEROKU_APP_NAME
